import { getFunctions, httpsCallable } from "firebase/functions";
import { PaymentInfo, SubscriptionStatus } from "../types";
import {reportRedditPixelTrial} from "./redditPixelHelper.ts";
import { captureException } from "../sentry";

const confirmSetupIntent = async (
  setupIntentId: string,
  setupIntentClientSecret: string
) => {
  try {
    const confirmSubscription = httpsCallable<unknown, null>(
      getFunctions(),
      "http-webOnboardingTrialStart"
    );

    const result = await confirmSubscription({ setupIntentId, setupIntentClientSecret });
    if(result.data) {
      reportRedditPixelTrial(setupIntentId)
    }
  } catch (error) {
    captureException(error as Error, { 
      context: 'confirmSetupIntent',
      extra: { setupIntentId }
    });
    return;
  }
};

const getSubscriptionStatus = async () => {
  try {
    const checkSubscriptionFn = httpsCallable<unknown, SubscriptionStatus>(
      getFunctions(),
      "http-webOnboardingSubscriptionStatus"
    );

    const result = await checkSubscriptionFn();
    return result.data;
  } catch (error) {
    captureException(error as Error, { 
      context: 'getSubscriptionStatus'
    });
    return null;
  }
};

const generateSubscription = async () => {
  try {
    const callable = httpsCallable<unknown, PaymentInfo>(
      getFunctions(),
      "http-webOnboardingSubscriptionIntent"
    );

    const result = await callable();
    return result.data;
  } catch (error) {
    captureException(error as Error, { 
      context: 'generateSubscription'
    });
    return null;
  }
};

export { generateSubscription, getSubscriptionStatus, confirmSetupIntent };
